import {Modal} from "antd";
import {Person} from "../../model/models";

interface ConfirmModalProps {
    visible: boolean,
    onConfirm: () => void,
    onCancel: () => void,
    title?: string,
    message?: string,
    confirmText?: string,
    cancelText?: string,
    loading?: boolean,
    person?: Person,
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
                                                       visible,
                                                       onConfirm,
                                                       onCancel,
                                                       title = "Conferma operazione",
                                                       message = "Sei sicuro di voler procedere?",
                                                       confirmText = "Conferma",
                                                       cancelText = "Annulla",
                                                       loading = false,
                                                   }) => {
    return (
        <Modal
            title={title}
            open={visible}
            onOk={onConfirm}
            onCancel={onCancel}
            okText={confirmText}
            cancelText={cancelText}
            confirmLoading={loading}
            maskClosable={!loading}
            closable={!loading}
        >
            <p>{message}</p>
        </Modal>
    );
};

export default ConfirmModal;
